export default {
  page: "OrderStatus"
};
